import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface GlobalState {
    isConsentApproved: boolean
    isBookedNow: boolean
    isLoading: boolean
    authToken: string | null
    loadingsCount: number
    viewStateErrorText: string | boolean
    viewStateErrorCode: number | boolean
    openedInviteModal: boolean
}

const initialState: GlobalState = {
    isConsentApproved: false,
    isBookedNow: false,
    isLoading: false,
    authToken: null,
    loadingsCount: 0,
    viewStateErrorText: false,
    viewStateErrorCode: false,
    openedInviteModal: false,
};

export const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        setConsentApproved: (state, action: PayloadAction<boolean>) => {
            state.isConsentApproved = action.payload;
        },
        setBookedNow: (state, action: PayloadAction<boolean>) => {
            state.isBookedNow = action.payload;
        },  
        setAuthToken: (state, action: PayloadAction<string | null>) => {
            action.payload ? localStorage.setItem('id_token', action.payload) : localStorage.removeItem('id_token');
            state.authToken = action.payload;
        },  
        loadingStart: (state) => {
            state.loadingsCount += 1;
            state.isLoading = true;
        },
        loadingEnd: (state) => {
            if (state.loadingsCount > 0) {
                state.loadingsCount -= 1;
            }
            if (state.loadingsCount <= 0) {
                state.isLoading = false;
            }
        },
        setViewStateErrorText: (state, action: PayloadAction<string | boolean>) => {
            state.viewStateErrorText = action.payload;
        },
        setViewStateErrorCode: (state, action: PayloadAction<number | boolean>) => {
            state.viewStateErrorCode = action.payload;
        },
        setOpenedInviteModal: (state, action: PayloadAction<boolean>) => {
            state.openedInviteModal = action.payload;
        },
    },
});

export const { setConsentApproved, setBookedNow, setAuthToken, loadingStart, loadingEnd, setViewStateErrorText, setViewStateErrorCode, setOpenedInviteModal } = globalSlice.actions;

export default globalSlice.reducer;